export enum Breakpoint {
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
}
